<template>
  <section class="ic-home-ping">
    <div class="ic-home-ping__inner">
      <div class="ic-home-ping__content">
        <span class="ic-home-pill">
          <Vibrate class="ic-home-pill__icon" :size="19" />
          Ping!
        </span>
        <h2 class="ic-home-ping__title ic-home-sectitle">Quando arriva,<br />te lo diciamo noi!</h2>
        <p class="ic-home-ping__lead">
          Crea un Ping! e facci sapere come la vuoi. Non appena viene creato un
          nuovo annuncio con le caratteristiche che cerchi, ti mandiamo un Ping!
        </p>
        <button type="button" data-testid="ping-cta" class="ic-home-btn ic-home-ping__btn" @click="createPing">
          Crea un Ping!
        </button>
      </div>
      <div class="ic-home-ping__media">
        <!-- Below the fold: lazy-loaded responsive WebP (public/img-opt/). -->
        <picture>
          <source
            type="image/webp"
            srcset="
              /img-opt/ping-family-480.webp 480w,
              /img-opt/ping-family-800.webp 800w,
              /img-opt/ping-family-1200.webp 1200w"
            sizes="(max-width: 1023.98px) 100vw, 50vw"
          />
          <img
            src="/img-opt/ping-family-800.jpg"
            alt="Bambina felice che guarda lo smartphone in cucina"
            loading="lazy"
            decoding="async"
            width="1448"
            height="1086"
          />
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import Vibrate from 'vue-material-design-icons/Vibrate.vue';

export default {
  name: 'HomePing',
  components: { Vibrate },
  emits: ['create'],
  data() {
    return {};
  },
  methods: {
    createPing() {
      // The Ping! area is auth-gated, so the parent (Home) decides whether to
      // log the user in first; either way it lands on /user/ping with the
      // "create new Ping!" popup already open.
      this.$emit('create');
    },
  },
};
</script>
